<div
  class="drop-zone"
  pcsFileDrop
  [disabled]="disabled"
  [accepts]="accepts"
  [fileSize]="fileSize"
  (fileDropped)="addFile($event)">

  <pcs-icon [icon]="icon" size="iconXXL" class="drop-zone-icon mb-2" [ngClass]="iconColor"></pcs-icon>

  <div class="d-flex flex-wrap justify-content-center align-items-center">
    <pcs-text-field textFieldValue="fileUpload.dragFile.message"
                    class="h-auto lh-1 col-auto p-0">
    </pcs-text-field>
    <pcs-file-select
      [disabled]="disabled"
      [accepts]="accepts"
      [fileSize]="fileSize"
      (fileSelected)="addFile($event)"
      class="col-auto ps-1 pe-0">
    </pcs-file-select>
  </div>
  <pcs-text-field textFieldValue="{{permittedFilesText | translate}}"
                  textFieldSize="small"
                  textFieldStyle="Info"
                  class="h-auto lh-1 col-auto mt-1">
  </pcs-text-field>
</div>

<pcs-file-list
  *ngIf="hasFiles()"
  [files]="[value]"
  (removed)="removeFile()">
</pcs-file-list>
